import {
  EditContext,
  EditingStoppedReason,
} from '@efdigital/ll-admin-v2/components/edit-context.gts';
import { EditLtiConsumedTool } from '@efdigital/ll-admin-v2/components/lti/edit-lti-consumed-tool.gts';
import { DataTypeLti } from '@efdigital/ll-admin-v2/data/data-types/lti';
import { deepRollback } from '@efdigital/ll-admin-v2/data/deep-rollback';
import type { LtiConsumedTool } from '@efdigital/ll-admin-v2/data/types/lti';
import { XCEED_PRODUCT } from '@efdigital/ll-admin-v2/utils/lti/products/xceed';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import type { Store } from '@warp-drive/core';
import BsModal from 'ember-bootstrap/components/bs-modal';

interface Signature {
  Args: {
    platformId: string;
    onSaved: (tool: LtiConsumedTool) => void;
  };
  Blocks: {
    trigger: [openModal: () => void];
  };
}

export default class LtiCreateToolModal extends Component<Signature> {
  @service declare store: Store;

  @tracked visible = false;
  @tracked tool?: LtiConsumedTool;

  openModal = (): void => {
    this.tool = this.store.createRecord<LtiConsumedTool>(
      DataTypeLti.ConsumedTool,
      {
        consumingPlatformId: this.args.platformId,
        providedToolId: XCEED_PRODUCT.providedToolId,
        platformData: {
          client_id: 'TODO',
          alg: 'RS256',
          jwks_url: 'TODO',
          jwks_json: null,
          authorizationEndpoint: 'TODO',
        },
      }
    );
    this.visible = true;
  };

  closeModal = (): void => {
    this.visible = false;
    this.tool = undefined;
  };

  handleEditingStopped = (reason: EditingStoppedReason) => {
    if (reason === EditingStoppedReason.Saved && this.tool) {
      this.args.onSaved(this.tool);
      this.closeModal();
      return;
    }

    if (reason !== EditingStoppedReason.Cancelled && this.tool) {
      deepRollback(this.tool, this.store);
    }

    this.closeModal();
  };

  <template>
    {{yield this.openModal to="trigger"}}
    <BsModal
      @open={{this.visible}}
      @onHidden={{this.closeModal}}
      @backdropClose={{false}}
      @size="lg"
      as |modal|
    >
      <modal.header>
        <h2 class="modal-title h5">{{XCEED_PRODUCT.registerButtonLabel}}</h2>
      </modal.header>
      <modal.body>
        {{#if this.tool}}
          <EditContext
            @onEditingStopped={{this.handleEditingStopped}}
            as |context|
          >
            <EditLtiConsumedTool
              @item={{this.tool}}
              @platformId={{@platformId}}
              @context={{context}}
              @initialState="edit"
            >
              <:help>

                <p class="lh-sm">
                  Create the consumed tool registration for
                  {{XCEED_PRODUCT.name}}. Use
                  <code>TODO</code>
                  for values the customer has not provided yet — you can update
                  them later after the customer configures their LMS.
                </p>
              </:help>
            </EditLtiConsumedTool>
          </EditContext>
        {{/if}}
      </modal.body>
    </BsModal>
  </template>
}
